export type contact = {
  userName: string
  name: string
};

const contacts_db: contact[] = [
  { userName: 'amalwanderlust',
    name: 'Amal Al-Faridi',
  },
  { userName: 'bilalbackpacks',
    name: 'Bilal Zakariya',
  },
  { userName: 'farisexplorer',
    name: 'Faris El-Amin',
  },
  { userName: 'jamaljourneys',
    name: 'Jamal Hadi',
  },
  { userName: 'karimtravels',
    name: 'Karim Abdelrahman',
  },
  { userName: 'laylajourneys',
    name: 'Layla Al-Hakim',
  },
  { userName: 'linaonthego',
    name: 'Lina Khalil',
  },
  { userName: 'nomadnadia',
    name: 'Nadia Saeed',
  },
  { userName: 'sarahseestheworld',
    name: 'Sarah Bahar',
  },
  { userName: 'yasmeenadventures',
    name: 'Yasmeen Darwish',
  },
  { userName: 'yousefyonder',
    name: 'Yousef Al-Khaled',
  },
  { userName: 'zaydinthewild',
    name: 'Zayd Alsalim',
  },
];

export default contacts_db;
